const CLOUD_API = 'https://horizon-11050536815.australia-southeast1.run.app';
const API_BASE_URL = `${(typeof window !== 'undefined' && window.location.hostname === 'localhost') ? 'http://localhost:3002' : CLOUD_API}/api`;

export interface TileGenerationRequest {
  aoiGeometry: any;
  minZoom: number;
  maxZoom: number;
  userType: string;
  includeNauticalOverlay: boolean;
  imagerySource?: 'sentinel2' | 'google';
  email?: string;
}

export interface JobStatus {
  id: string;
  status: 'queued' | 'processing' | 'completed' | 'failed';
  progress: number;
  currentTile?: number;
  totalTiles?: number;
  successfulTiles?: number;
  failedTiles?: number;
  statusMessage?: string;
  downloadUrl?: string;
  error?: string;
  createdAt: string;
  completedAt?: string;
}

export class ApiService {
  /**
   * Create a new tile generation job
   */
  static async createJob(request: TileGenerationRequest): Promise<{ jobId: string }> {
    console.log('[ApiService] createJob called with request:', JSON.stringify(request, null, 2));
    const response = await fetch(`${API_BASE_URL}/jobs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to create tile generation job');
    }

    return response.json();
  }

  /**
   * Get job status
   */
  static async getJobStatus(jobId: string): Promise<JobStatus> {
    const response = await fetch(`${API_BASE_URL}/jobs/${jobId}`);

    if (!response.ok) {
      throw new Error('Failed to fetch job status');
    }

    return response.json();
  }

  /**
   * Poll for job completion
   */
  static async pollJobUntilComplete(
    jobId: string,
    onProgress?: (status: JobStatus) => void
  ): Promise<JobStatus> {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const status = await this.getJobStatus(jobId);

          if (onProgress) {
            onProgress(status);
          }

          if (status.status === 'completed') {
            clearInterval(interval);
            resolve(status);
          } else if (status.status === 'failed') {
            clearInterval(interval);
            reject(new Error(status.error || 'Job failed'));
          }
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }, 1000); // Poll every second
    });
  }
}
